module.exports = __webpack_public_path__ + "static/media/medicationstatement.js.23913e4f.map";